var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearFliters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2062_7843)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8285 9.01948V12.6666C9.8285 13.0333 10.1301 13.3333 10.4988 13.3333H11.8394C12.2081 13.3333 12.5097 13.0333 12.5097 12.6666V8.66663C12.5097 8.66663 15.0032 5.46663 16.3572 3.73996C16.6991 3.29996 16.3841 2.66663 15.8277 2.66663H9.60938C9.91339 3.07157 10.1633 3.51957 10.3484 3.99996H14.5206L11.1624 8.19996L10.5371 7.41478C10.3859 7.99189 10.1444 8.53211 9.8285 9.01948Z",
    fill: "#89A6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 6.00004C0.5 3.41937 2.586 1.33337 5.16667 1.33337C7.74733 1.33337 9.83333 3.41937 9.83333 6.00004C9.83333 8.58071 7.74733 10.6667 5.16667 10.6667C2.586 10.6667 0.5 8.58071 0.5 6.00004ZM6.89333 3.33337L5.16667 5.06004L3.44 3.33337L2.5 4.27337L4.22667 6.00004L2.5 7.72671L3.44 8.66671L5.16667 6.94004L6.89333 8.66671L7.83333 7.72671L6.10667 6.00004L7.83333 4.27337L6.89333 3.33337Z",
    fill: "#FF7A7A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2062_7843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearFliters);
export default __webpack_public_path__ + "static/media/clear-fliters.95faae20e1b581db250dd9e7b4cc9761.svg";
export { ForwardRef as ReactComponent };